<template>
  <v-container fluid grid-list-lg class="pt-3">
    <v-layout row wrap>
      <v-flex xs12 md4 lg3 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card height="100%" style="overflow: auto">
          <v-system-bar color="accent" dark window>
            <v-icon center>mdi-account-group</v-icon>
            <v-menu offset-y bottom min-width="300">
              <v-btn slot="activator" flat class="title mx-0" style="text-transform: capitalize">{{ (type==='org') ? 'Оргструктура' : 'Анкеты' }}<v-icon>mdi-menu-down</v-icon></v-btn>
              <v-list>
                <v-list-tile @click="getData('form')">Анкеты</v-list-tile>
                <v-list-tile @click="getData('org')">Оргструктура</v-list-tile>
              </v-list>
            </v-menu>
          </v-system-bar>
          <v-layout row wrap>
            <template v-if="type==='form'">
              <v-flex xs12 class="mx-2">
                <b>Текущие сотрудники</b>
                <dantser-tree
                  ref="c_employeesTree"
                  :selectMode="1"
                  :source="current_employees"
                  @click-node="anketaCliked($event, 'active')"
                ></dantser-tree>
              </v-flex>
              <v-flex xs12 class="mx-2" v-if="dismissed_employees.length>0">
                <b>Уволенные сотрудники</b>
                <dantser-tree
                  ref="d_employeesTree"
                  :selectMode="1"
                  :source="dismissed_employees"
                  @click-node="anketaCliked($event, 'non_active')"
                ></dantser-tree>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 class="mx-2">
                <b>Текущие посты</b>
                <dantser-tree
                  ref="postsTree"
                  :selectMode="1"
                  :source="treedata"
                  @click-node="nodeClicked($event)"
                ></dantser-tree>
              </v-flex>
              <v-flex xs12 class="mx-2" v-if="deleted_posts.length>0">
                <b>Удаленные посты</b>
                <dantser-tree
                  ref="dismissedTree"
                  :selectMode="1"
                  :source="deleted_posts"
                  @click-node="nodeClicked($event)"
                ></dantser-tree>
              </v-flex>
            </template>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md8 lg9 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card height="100%" style="overflow: auto">
          <v-system-bar color="accent" dark window>
            <v-icon center>mdi-account-card-details</v-icon>
            <v-toolbar-title class="ml-1">Анкета</v-toolbar-title>
          </v-system-bar>
          <v-layout v-if="loading">
            <v-flex xs12>
              <div class="py-5 text-xs-center">
                <v-progress-circular :size="60" :width="5" color="primary" indeterminate></v-progress-circular>
                <p class="mt-3">Данные загружаются. Пожалуйста подождите.</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap id="to-print" v-else-if="currentNode">
            <v-flex xs12 class="px-4 pt-3" v-if="currentNode.element_type!=='form'"><h2>{{currentNode.name}}</h2></v-flex>
            <template v-if="currentNode.element_type!=='container'">
              <template v-if="!hasAnketa">
                <v-flex xs12 sm9 class="pa-4">
                  <p class="title">Данный пост никем не занят</p>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs12 sm3 class="pa-4 text-xs-center">
                  <img v-if="photo" :src="photoToken" alt="avatar" width="100%" style="max-width: 300px">
                  <v-btn color="secondary" small dark @click="showCrop=!showCrop" v-if="editMode">Загрузить фото <v-icon right dark>cloud_upload</v-icon></v-btn>
                  <my-upload field="file"
                             @crop-upload-success="cropUploadSuccess"
                             v-model="showCrop"
                             :url="uploadUrl"
                             langType="ru"
                             :headers="headers"
                             :params="params"
                  ></my-upload>
                </v-flex>
                <v-flex xs12 sm9 class="pa-4">
                  <v-btn color="info" small v-if="accesses.form_update && allowEdit" class="pull-right hide-on-print"  :class="{info:!editMode, success:editMode}" @click="editAnketa">
                    {{editMode?'Сохранить':'Редактировать'}}
                  </v-btn>
                  <v-btn color="warning" small class="pull-right hide-on-print" @click="printAnketa" v-if="!editMode">
                    Печатать
                  </v-btn>
                  <v-btn color="success" small class="pull-right hide-on-print" @click="attachStatuses">
                    Статусы
                  </v-btn>
                  <div class="subheading" :class="{'py-2':!editMode}" v-for="(field, index) in fields_default" :key="`default-${index}`">
                    <component :is="field.component" :label="field.name" v-bind="field.options" style="max-width:350px" v-if="editMode" v-model="field.value"></component>
                    <template v-else>
                      <b>{{field.name}}: </b> <span v-if="field.value!=null">{{formatValue(field.value)}}</span><small v-else>(не заполнено)</small>
                    </template>
                  </div>
                  <v-chip v-for="item in formStatuses" :color="item.color" :dark="darkBg(item.color)" :key="item.id">
                    <v-icon size="20" left class="mr-1">{{item.icon}}</v-icon>{{item.name}}
                  </v-chip>
                </v-flex>
                
                <v-flex xs12 lg6 class="px-4 py-0" v-for="(field, index) in fields_other" :key="`other-${index}`">
                  <div class="subheading" :class="{'py-2':!editMode}">
                    <component :is="field.component" :label="field.name" v-bind="field.options" style="max-width:350px" v-if="editMode" v-model="field.value"></component>
                    <template v-else>
                      <b>{{field.name}}: </b> <span v-if="field.value!=null">{{formatValue(field.value)}}</span><small v-else>(не заполнено)</small>
                    </template>
                  </div>
                </v-flex>
              </template>
              <v-flex xs12 class="px-4" v-if="other_posts.length>0">
                <p class="subheading mb-0"><b>Посты, занимаемые в компании:</b></p>
                <ul class="pl-3">
                  <li v-for="(post, index) in other_posts" :key="index">{{post.name}} <v-chip
                    :color="post.active?'green lighten-4':'red lighten-4'" label disabled small class="ml-0"
                  >{{post.date}}</v-chip></li>
                </ul>
              </v-flex>
              <v-flex xs12 class="px-4" v-if="archive.length>0 && accesses['archive-form_access']">
                <p class="subheading mb-0"><b>Список сотрудников, занимавших данный пост ранее:</b></p>
                <ul class="pl-3">
                  <li v-for="(anketa, index) in archive" :key="index" class="my-2">
                    <a class="body-1" @click="getAnketa(anketa.form_id)">{{anketa.fio}}</a>
                    <v-chip  label disabled small class="ml-0">{{anketa.date}}</v-chip>
                  </li>
                </ul>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 class="px-4 pt-3"><p class="subheading" v-html="container_description"></p></v-flex>
            </template>
          </v-layout>
          <v-layout v-else row>
            <v-flex xs12 class="pa-4"><h3>Выберите пост для загрузки анкеты</h3></v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="1000" persistent>
      <component :is="currentComponent" v-bind="formProps" v-if="dialog" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  import myUpload from 'vue-image-crop-upload'
  import httpClient from '@/api/http-client'
  import AnketaArchived from './AnketaArchived'
  import StatusAttach from './Forms/StatusAttach'
  import dDatePicker from '../Common/dDatePicker'
  import {mapState} from 'vuex'
  import {is_dark} from '@/helpers/app'
  
  export default {
    name : 'Anketa',
    
    components: {
      myUpload,
      dDatePicker
    },
  
    computed:{
      ...mapState(`app/account`, ['postId']),
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
      accesses(){
        return this.$store.state.app.account.accesses['worksheet'] || {}
      },
      headers(){
        return {'Authorization': httpClient.config.headers.Authorization }
      },
      photoToken(){
        if(!this.photo) return "/static/images/user_default.png"
        let result = this.photo
        if(this.photo.indexOf('base64')<0 && this.photo.indexOf('http')<0){
          result = `/disk/d/preview/resize/500x500/${this.photo}`
        }
        return result
      },
      params(){
        if(this.currentNode && this.currentNode.account_id){
          return { user_id: this.currentNode.account_id}
        }
        return { user_id: ''}
      }
    },
    
    data() {
      return {
        uploadUrl: process.env.WORKSHEET_UPLOAD_URL || '/api/private/disk/v1/worksheet/avatar/',
        treedata: [],
        deleted_posts: [],
        current_employees: [],
        dismissed_employees: [],
        other_posts: [],
        photo: '',
        archive: [],
        fields_default: [],
        fields_other: [],
        editMode: false,
        showCrop: false,
        currentNode: null,
        container_description: '',
        form_id: null,
        formProps: {},
        dialog: false,
        loading: false,
        hasAnketa: true,
        type: null,
        allowEdit: false,
        currentComponent: null,
        formStatuses: []
      }
    },
  
    created(){
      if(!this.accesses.form_access ){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      } else {
        this.getData('org')
        this.$store.dispatch('app/anketa/loadStatusesTree')
      }
    },
    
    methods : {
      formatValue(data){
        switch(typeof data){
          case 'string': return data;
          case 'boolean': return data ? 'Да' : 'Нет'
          case 'object':
            let result = ''
            for(let item of data) result+=item+', '
            return result.trim()
        }
      },
      
      getData(type){
        if(this.type!==type){
          this.type = type
          if(type==='form'){
            this.$store.dispatch('orgstructure/anketa/getForms').then(response => {
              this.current_employees = response.active
              this.dismissed_employees = response.no_active
            })
          } else {
            this.$store.dispatch('orgstructure/getDeletedPosts').then(response => {
              this.deleted_posts = response
            })
            this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
              this.treedata = usersTree
            })
          }
        }
      },
  
      nodeClicked(node){
        this.clearData()
        this.currentNode = node
        this.loading = true
        if(node.element_type==='post'){
          this.$store.dispatch('orgstructure/anketa/view', node.id).then(response => {
            this.loading = false
            this.allowEdit = true
            this.other_posts = response.posts
            this.photo = response.form_photo
            this.fields_default = response.form.default
            this.fields_other = response.form.other
            this.archive = response.archive
            this.form_id = response.form_id
            this.hasAnketa = (typeof response.form_id!=='undefined')
            this.$store.dispatch('orgstructure/anketa/getFormStatuses' , {id_type: 'form', id: this.form_id}).then( response => {
              this.formStatuses = response
            })
          })
        } else {
          this.$store.dispatch('orgstructure/getElement', node.id).then(response => {
            this.loading = false
            this.container_description = response.description
          })
        }
      },
      
      anketaCliked(node, type){
        this.clearData()
        this.currentNode = node
        this.currentNode.element_type = 'form'
        this.loading = true
        this.hasAnketa = true
        this.form_id = node.id
        this.archive = []
        
        if(type==='active'){
          this.$store.dispatch('orgstructure/anketa/getActive', node.id).then(response => {
            this.loading = false
            this.allowEdit = true
            this.other_posts = response.posts
            this.photo = response.form_photo
            this.fields_default = response.form.default
            this.fields_other = response.form.other
          })
        } else {
          this.$store.dispatch('orgstructure/anketa/getArchive', node.id).then(response => {
            this.loading = false
            this.allowEdit = false
            this.other_posts = response.posts
            this.photo = response.form_photo
            this.fields_default = response.form.default
            this.fields_other = response.form.other
          })
        }
        this.$store.dispatch('orgstructure/anketa/getFormStatuses' , {id_type: 'form', id: this.form_id}).then( response => {
          this.formStatuses = response
        })
        
      },
      
      clearData(){
        this.container_description = ''
        this.editMode = false
        this.other_posts = []
        this.photo = null
        this.fields_default = []
        this.fields_other = []
        this.archive = []
        this.form_id = null
        this.allowEdit = false
      },
      
      editAnketa(){
        if(this.editMode){
          let data = {
            form_photo: this.photo,
            form:{ default: this.fields_default, other: this.fields_other }
          }
          this.$store.dispatch('orgstructure/anketa/update', {id: this.form_id, data: data}).then(response => {
            this.editMode=false
          })
        } else {
          this.editMode=true
        }
      },
      
      getAnketa(id){
        this.$store.dispatch('orgstructure/anketa/getArchive', id).then(response => {
          this.formProps = { form: response.form, posts: response.posts, form_photo: response.form_photo }
          this.currentComponent = AnketaArchived
          this.dialog = true
        })
      },
      
      printAnketa(){
          const mywindow = window.open('', 'PRINT', 'height=600,width=900');
          mywindow.document.write('<html><head><title>Анкета</title>');
          mywindow.document.write('<style>.hide-on-print{display:none}</style></head><body >');
          mywindow.document.write(document.getElementById('to-print').innerHTML);
          mywindow.document.write('</body></html>');
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10*/
          mywindow.print();
          mywindow.close();
          return true;
      },
      
      cropUploadSuccess(jsonData, field){
        this.photo = jsonData.token
      },
  
      saveChanges(eventData){
        switch(eventData.type){
          case 'statuses':
            this.formStatuses = eventData.data
            break
        }
        this.dialog = false
      },
      
      attachStatuses(){
        this.currentComponent = StatusAttach
        this.formProps = {
          id: this.form_id,
          data: this.formStatuses
        }
        this.dialog = true
      },
  
      darkBg(color){
        return color ? is_dark(color) : false
      },
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Anketa/Anketa.vue